import shared from "emun.cart/cart.config.es6"; //get shared
export const IS_PROD = (ENV_TAGS || []).indexOf("Prod") >= 0;
export const IS_CMS = (ENV_TAGS || []).indexOf("Cms") >= 0;

export default Object.assign(shared, {
  askQuestions: false,
  lblPromoStatus: "Promotions",
  categoryRestrictions: {
    141: true,
    142: true,
    143: true,
    144: true,
    158: true,
  },
  hideVendor: false,
  hideAcceptTerms: true,
  showAcceptTerms: false,
  requireAcceptTerms: false,
  hideVendorScanOption: false,
  hideModifyCCMessage: true,
  autoAdd: true,
  exactMatchShowroomOnly: true,
  vendorScan: false,
  hideCancelDt: false,
  splitOnCheckout: true,
  closeQuickViewOnSubmit: false,
  orderConfirmationPage: true,
  outOfStockText: "notext",
  showAdvancedShipButton: true,
  showCheckoutForms: true,
  showAvailableQty: true,
  exportBoxRoles: ["Vendor"],
  resendOrders: true,
  vendorMinimums: true,
  hideExportBox: false,
  cartLoading(cart, session) {
    cart.cartTitle = session.isSalesManagementMode()
      ? "Order"
      : shared.cartTitle;
    cart.acceptTerms = true;
    cart.acceptTermsMessage = `<br>Make sure all required Vendor forms are COMPLETED!<br>Schedule and Enter retailers Exit Appointment in EMUN!`;
  },
  orderDateRoles: ["Administrator"],
  showCancelButton: true,
  allowMultipleVendors: false,
  mfgOneVendorPerOrder: "Silent",
  useAptean(cart) {
    return cart.vendorId == '148' || cart.vendorId == '149';
  },
  usePayfabric(cart) {
    return cart && cart.vendorId == '2';
  },
  useHostedPCI(cart) {
    if (cart == undefined) return true;
    return cart.vendorId != '148' && cart.vendorId != '149' && cart.vendorId != '2';
  },
  //payfabricWalletPage: "https://sandbox.payfabric.com/Payment/Web/Wallet/Create?tender=CreditCard&customer=",
  payfabricWalletPage: "https://www.payfabric.com/Payment/Web/Wallet/Create?tender=CreditCard&customer=",
  useEMUNTokenization: true,
  hidePriceList: false,
  multiCart: IS_CMS ? true : false,
  useTokenex(cart) {
    return false;
    // if (cart && cart.vendorId == '170') return true;
    // else return false;
  }
});
